import {Component, computed, inject, input} from '@angular/core';
import {FormControl} from '@angular/forms';
import {TranslatePipe} from '@ngx-translate/core';
import {Dropdown} from '../../../../components/dropdown/dropdown';
import {MultiDropdown} from '../../../../components/multi-dropdown/multi-dropdown';
import {ActivityTypeSelect, ActivityTypeService} from '../../../../../api';
import {injectQuery} from '@tanstack/angular-query-experimental';
import {lastValueFrom} from 'rxjs';
import {QueryKey} from '../../../../constants/query-key';

@Component({
  selector: 'elcia-activity-type-dropdown',
  imports: [Dropdown, MultiDropdown, TranslatePipe],
  templateUrl: './activity-type-dropdown.html',
})
export class ActivityTypeDropdown {
  private readonly activityTypeService = inject(ActivityTypeService);

  isMulti = input.required<boolean>();
  control = input.required<FormControl>();

  private readonly activityTypesQuery = injectQuery(() => ({
    queryKey: [QueryKey.ACTIVITY_TYPES_SELECT],
    queryFn: () => lastValueFrom(this.activityTypeService.getActivityTypeSelect()),
  }));

  protected readonly activityTypes = computed<ActivityTypeSelect[]>(
    () => this.activityTypesQuery.data()?.activityTypes ?? []
  );
}
